<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  
  <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
          <i class="bi bi-arrow-left"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.print_preview || 'Print Preview' }}</h2>
        </div>
        <div class="header-action">
          <!-- <button class="btn-add" data-bs-toggle="offcanvas" data-bs-target="#branch">
            <i class="bi bi-plus"></i>
          </button> -->

        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <!-- CSV Upload Section -->
      <!--<div class="csv-section">-->
      <!--  <div class="section-header">-->
      <!--    <h3>Bulk Import</h3>-->
      <!--  </div>-->
      <!--  <div class="csv-card">-->
      <!--    <div class="csv-content">-->
      <!--      <div class="csv-icon">-->
      <!--        <i class="bi bi-file-earmark-spreadsheet"></i>-->
      <!--      </div>-->
      <!--      <div class="csv-info">-->
      <!--        <h4>Upload CSV File</h4>-->
      <!--        <p>Import multiple students at once</p>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <div class="csv-action">-->
      <!--      <label for="csv-upload" class="btn-csv">-->
      <!--        <i class="bi bi-cloud-upload"></i>-->
      <!--        Upload CSV-->
      <!--      </label>-->
      <!--      <input -->
      <!--        id="csv-upload" -->
      <!--        type="file" -->
      <!--        @change="handleFileUpload" -->
      <!--        accept=".csv" -->
      <!--        hidden-->
      <!--      />-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->

      <!-- Student List Section -->

      <div class="print-preview">
      <button  @click="printPreview">
    <i class="bi bi-printer"></i>
  </button>
        </div>


<div class="admission-page a4">

  <!-- HEADER -->
<!-- HEADER -->
<div class="text-center mb-2">

  <!-- TOP AFFILIATION LINE -->
  <div class="small fw-bold">
    श्री.कलापिनी संगीत शिक्षण प्रसारक मंडळ संचलित  
    (रजि. नं. F-0030106/SLP. Dt.24/09/2018)
  </div>

  <!-- MAIN TITLE -->
  <h5 class="fw-bold text-purple mt-1">
    श्री. कलापिनी संगीत विद्यालय, पंढरपूर
  </h5>

  <!-- AFFILIATION DETAILS -->
  <div class="small fw-semibold">
    सलंग्न – अखिल भारतीय गांधर्व महाविद्यालय मंडळ, मुंबई (मिरज)  
    <br>
    (केंद्र क्र. 647)
  </div>

  <div class="small">
    Affiliation Number – AMM-61, ISO 9001:2015 NO. 5834/QMS/0120  
    <br>
    SA NO.102927401903, MSME UA NO. MH32D0023126
  </div>

  <!-- REGISTER OFFICE -->
  <div class="small fw-semibold mt-1">
    रजिस्टर कार्यालय :- आरोही स्वरा बिल्डिंग, खंडाळी, ता. मोहोळ,  
    जि. सोलापूर – 413324
  </div>

  <!-- SLOGAN -->
  <div class="small fw-bold mt-1">
    | एक संस्कार | कलेचा |
  </div>

  <!-- BRANCH ADDRESS -->
  <div class="small fw-bold mt-1">
    शाखा – पंढरपूर – DVP SQUARE THEATER, चौथा मजला,  
    KBP COLLEGE ROAD, पंढरपूर  
    ता. पंढरपूर, जि. सोलापूर – 413304
  </div>

</div>

<!-- CONTACT + PHOTO -->
<div class="d-flex justify-content-between align-items-center mb-2">
  <div class="small fw-semibold">
    📞 9307689653 / 9822730484  
    <br>
    ✉️ ksvidyalay@gmail.com  
    <br>
    🌐 www.ksvidyalay.com
  </div>


    <div class="photo-box" v-if="studentlist.student_img">
    <img
        :src="$hostname + 'uploads/student_img/' + studentlist.student_img"
        alt="विद्यार्थी फोटो"
        class="student-photo"
      />
    </div>

  <div class="photo-box" v-else>
    विद्यार्थी<br>फोटो
  </div>
</div>


  <hr>

  <!-- FORM TITLE -->
  <div class="text-center my-2">
    <span class="star">★</span>
    <span class="form-title">प्रवेश फॉर्म 2025</span>
    <span class="star">★</span>
  </div>

  <!-- SUBJECT LINE -->
  <div class="row mt-3">
    <div class="col-4">विषय : <span class="line">{{ studentlist.subject_name }}</span></div>
    <div class="col-4">विभाग : <span class="line">{{ studentlist.department }}</span></div>
    <div class="col-4">शाखा : <span class="line">{{ studentlist.branch }}</span></div>
  </div>

  <div class="form-line">1) विद्यार्थ्याचे संपूर्ण नाव : <span class="long-line"> {{ studentlist.student_name }}</span></div>

  <div class="row">
    <div class="col-4">2) जन्मतारीख : <span class="line">{{ studentlist.dob }}</span></div>
    <div class="col-4">3) मोबाईल : <span class="line">{{ studentlist.mobile }}</span></div>
    <div class="col-4">4) Email : <span class="line">{{ studentlist.email }}</span></div>
  </div>

  <div class="row">
    <div class="col-4">5) शालेय शिक्षण : <span class="line">{{ studentlist.shalay_shikshan }}</span></div>
    <div class="col-4">6) धर्म : <span class="line">{{ studentlist.religion }}</span></div>
    <div class="col-4">7) जात : <span class="line">{{ studentlist.caste }}</span></div>
  </div>

  <div class="row">
    <div class="col-6">8) आधार नं. : <span class="line">{{ studentlist.aadhar_number }}</span></div>
  </div>

  <div class="form-line">9) वडिलांचे संपूर्ण नाव : <span class="long-line">{{ studentlist.father_name }}</span></div>

  <div class="row">
    <div class="col-6">10) व्यवसाय : <span class="line">{{ studentlist.occupation }}</span></div>
  </div>

  <div class="row">
    <div class="col-6">11) WhatsApp Number : <span class="line">{{ studentlist.whatsapp }}</span></div>
    <div class="col-6">12) इतर संपर्क : <span class="line">{{ studentlist.other_contact }}</span></div>
  </div>

  <div class="row">
    <div class="col-6">13) आईचे नाव : <span class="line">{{ studentlist.mother_name }}</span></div>
    <div class="col-6">14) संपर्क : <span class="line">{{ studentlist.contact }}</span></div>
  </div>

  <div class="form-line">15) कार्य : <span class="long-line">{{ studentlist.kary }}</span></div>
  <div class="form-line">16) पत्ता : <span class="long-line">{{ studentlist.address }}</span></div>
   <div class="form-line">17) कायमचा पत्ता : <span class="long-line"></span></div> 

  <div class="row">
    <div class="col-4">18) निवडलेला विषय : <span class="line">{{ studentlist.selected_subject }}</span></div>
    <div class="col-4">19) परीक्षा : <span class="line">{{ studentlist.exam_name }}</span></div>
    <div class="col-4">20) क्लासची वेळ : <span class="line"></span></div>
  </div>

  <div class="row">
    <div class="col-6">21) प्रवेश तारीख : <span class="line">{{ studentlist.admission_date }}</span></div>
    <div class="col-6">22) फी प्रकार : <span class="line">{{ studentlist.fee_details }}</span></div>
  </div>

  <div class="form-line">23) माहिती आपणास कोठून मिळाली : <span class="long-line">{{ studentlist.information_source }}</span></div>

  <div class="d-flex justify-content-between mt-4">
    <div>विद्यार्थी सही : _____________</div>
    <div>पालकाची सही : _____________</div>
  </div>

</div>

<!-- ================= PAGE 2 ================= -->

<div class="admission-page a4">

  <!-- OFFICE TITLE -->
  <div class="text-center my-2">
    <span class="star">★</span>
    <span class="office-title">कार्यालयीन</span>
    <span class="star">★</span>
  </div>

  <div class="row">
    <div class="col-8">विद्यार्थी नाव : <span class="line">{{ studentlist.student_name }}</span></div>
    <div class="col-4">PRN : <span class="line">{{ studentlist.student_prn }}</span></div>
  </div>

  <div class="row mt-2">
    <div class="col-4">विषय : <span class="line">{{ studentlist.student_subject  }}</span></div>
    <div class="col-4">विभाग : <span class="line">{{ studentlist.student_vibhag  }}</span></div>
    <div class="col-4">प्रवेश <span class="line">{{ studentlist.admission_status }}</span></div>
  </div>

  <div class="row mt-2">
    <div class="col-4">दिनांक : <span class="line">{{ studentlist.student_entry_date }}</span></div>
  </div>

  <hr>

  <!-- RULES TITLE -->
  <div class="text-center my-2">
    <span class="star">★</span>
    <span class="rules-title">विद्यार्थी व पालक यांचे हमीपत्र</span>
    <span class="star">★</span>
  </div>
<p class="small text-justify rules-text">

1) या विद्यालयात प्रवेश घेताना प्रथम नाव नोंदणी फॉर्म भरणे बंधनकारक असून आपला स्वतंत्र 
<b>PRN (Permanent Register Number)</b> घेणे बंधनकारक आहे. यासाठी प्रवेश फी रु.1000/- 
ही एकदाच भरायची आहे. त्यानंतर आपणास PRN मिळेल जो कायमचा असून तो कधीही बदलला 
जाणार नाही व PRN फी परत मिळणार नाही. PRN एकदा ज्या व्यक्तीस दिला तो नंतर बदलता 
येणार नाही. PRN नसलेल्या अथवा नियमांनुसार प्रवेश न घेतलेल्या विद्यार्थ्यांना विद्यालय 
आवारात येण्यास परवानगी नाही. अशा विद्यार्थ्यांना वार्षिक परीक्षेस सलंग्नची मान्यता मिळणार 
नाही व अशा विद्यार्थ्यांचे होणारे एकूण सांगीतिक नुकसानीस विद्यालय जबाबदार राहणार नाही.
<br><br>

2) विद्यालयामार्फत देण्यात येणारे ओळखपत्र (I-Card), नियोजन पुस्तिका (Calendar), 
गणवेश (Dress Code) प्रत्येक वेळी क्लासला येताना सोबत आणणे बंधनकारक आहे. 
सरावावाचून विद्यार्थ्याचे होणारे कोणतेही नुकसान विद्यालय जबाबदार राहणार नाही.
<br><br>

3) विद्यालयातील सर्व विद्यार्थ्यांनी हजेरी बुकवर स्वतः सही करावी. हजेरी व एकूण प्रगतीचा 
विचार करूनच वार्षिक परीक्षेस बसण्यास परवानगी दिली जाईल. पूर्वकल्पना दिल्याशिवाय 
क्लासला गैरहजर राहू नये. गैरहजरीसाठी “गैरहजर पूर्वकल्पना फॉर्म” भरणे बंधनकारक आहे. 
हा फॉर्म भरून विद्यालयात जमा करणे ही विद्यार्थी व पालकाची जबाबदारी आहे.
<br><br>

4) विद्यालयातील सर्व विद्यार्थ्यांसाठी क्लास संदर्भातील सर्व महत्त्वाच्या सूचनांसाठी 
<b>WhatsApp Group</b> असणार आहे. याच माध्यमातून सर्व सूचना दिल्या जातील. 
या Group मधून left होणाऱ्या विद्यार्थ्यांना कोणत्याही सूचना स्वतंत्र दिल्या जाणार नाहीत 
व त्यातून होणाऱ्या गैरसोयीस विद्यालय जबाबदार राहणार नाही. WhatsApp सुविधा नसल्यास 
याची पूर्वकल्पना विद्यालयास द्यावी. संपर्क क्रमांक, पत्ता किंवा क्लास संदर्भातील बदल 
झाल्यास तात्काळ माहिती देणे बंधनकारक आहे.
<br><br>

5) विद्यालयामार्फत होणाऱ्या सर्व कार्यक्रमांना विद्यार्थी उपस्थित व सहभागी असणे बंधनकारक आहे.
<br><br>

6) क्लासमध्ये आल्यानंतर प्रथम देवतेस वंदन व गुरुप्रणाम करूनच बसावे. क्लासमधील सर्व 
विद्यार्थ्यांचे परस्पर नाते गुरुबंधू व गुरुबहीण असेच असावे.
<br><br>

7) जानेवारी 2018 पासून विद्यालयाची सर्व प्रकारची फी विद्यालयाच्या बँक खात्यावर जमा 
करणे बंधनकारक आहे. Online फी भरल्यास त्याची पावती विद्यालयाकडून घ्यावी. 
बँक खात्यावर फी जमा नसेल तर ती फी भरलेली समजली जाणार नाही.
<br><br>

8) सत्र परीक्षा देणे हे विद्यालयाच्या परीक्षा विभागाचा महत्त्वपूर्ण निर्णय असून तो बंधनकारक 
आहे. सत्र परीक्षा न देणाऱ्या विद्यार्थ्यांना वार्षिक परीक्षेस बसता येणार नाही व अशा विद्यार्थ्यांचा 
गुणवंत विद्यार्थी पुरस्कारासाठी विचार केला जाणार नाही.
<br><br>

9) कोणत्याही प्रकारचे व्यसनी पदार्थ व त्यांचे सेवन करणाऱ्या विद्यार्थ्यांना विद्यालय 
आवारात सक्त मनाई आहे.
<br><br>

10) विद्यालयाचे शैक्षणिक वर्ष जानेवारी ते डिसेंबर असे 12 महिन्यांचे असेल. वर्षामध्ये 
मधून प्रवेश घेतल्यास संपूर्ण वर्षाची फी भरणे बंधनकारक आहे. मंडळाच्या परीक्षा फॉर्म रद्द 
झाल्यास विद्यालय जबाबदार राहणार नाही.
<br><br>

11) विद्यालयाचे नियम व शिस्त मोडणाऱ्या विद्यार्थ्यांचे प्रवेशपत्र तात्काळ रद्द करण्यात येईल 
व त्यांचा PRN Block केला जाईल. अशा विद्यार्थ्यांना भविष्यात कधीही प्रवेश दिला जाणार नाही.
<br><br>

12) विद्यालयातील सर्व निर्णय फक्त प्राचार्य 
<b>श्री. प्रमोद पाटील (दादा)</b> यांच्या परवानगीनेच होतील.
<br><br>

13) पालक किंवा विद्यार्थ्यांच्या काही अडचणी अथवा सूचना असल्यास त्या प्राचार्याकडे 
लेखी स्वरूपात सादर कराव्यात.
<br><br>

14) विद्यालयाबाबत मत व्यक्त करताना प्रत्यक्ष भेटून करावे. समाजमाध्यमांचा गैरवापर, 
संभ्रम निर्माण किंवा बदनामी केल्यास कायदेशीर कारवाई करण्यात येईल.
<br><br>

15) संगीत विषयातील एखादा विभाग काही कारणास्तव बंद केला जाऊ शकतो.

</p>


  <div class="d-flex justify-content-between mt-4">
    <div>विद्यार्थी सही : _____________</div>
    <div>पालकाची सही : _____________</div>
  </div>

</div>


















   
    </main>

















  </div>
</template>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  mounted() { 
    if(this.$route.query.id){
      this.getBranches(this.$route.query.id);
    } else {
      this.getBranches();
    }
  
  },
  data() {

    return { 
      loading: false,
    
      error: null,
      isUserLogged: false,
      user_details: [],
      language: this.getLocalStorageArray('lang'),



      studentlist: [], 
      branch_name: '',
    }
  },
  methods: {
    initializeHomeContent() {
      // Initialization if needed
    },

        printPreview() {
  window.print();
},


        add_new_staff() {
     this.subject= {
        name: '',
        status: 1,
        code: '',
        description: '',
      };



    

    },
    
    goBack() {
      this.$router.go(-1);
    },
    
    goprevious() {
      this.$router.push("/branch");
    },

    async getBranches(id) {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;
        axios.post("getprintpreview", { id: id }).then((response) => {
          self.studentlist = response.data.studentlist;
          self.language = response.data.language;

          self.studentregistration.examid = id;
          localStorage.setItem('lang', response.data.language);
        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 


 

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },



  }
}
</script>

<style scoped>
.text-sm{
    font-size: 14px;
}
.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.back-button:active {
  background: rgba(255, 255, 255, 0.2);
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-add {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s;
}

.btn-add:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.95);
}

.main-content {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.section-header {
  margin-bottom: 16px;
}

.section-header h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.student-count {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.csv-section {
  margin-bottom: 24px;
}

.csv-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.csv-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.csv-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #4caf50;
}

.csv-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  color: #2c3e50;
}

.csv-info p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.btn-csv {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-csv:active {
  background: #388e3c;
  transform: scale(0.98);
}

.student-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.student-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.student-card-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.student-avatar {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #0056c2;
  flex-shrink: 0;
}

.student-info {
  flex: 1;
}

.student-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.student-header h4 {
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.student-number {
  font-size: 12px;
  color: #7f8c8d;
  background: #f5f7fa;
  padding: 4px 8px;
  border-radius: 8px;
}

.student-details {
  margin-bottom: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
  font-size: 14px;
  color: #7f8c8d;
}

.student-status {
  margin-top: 8px;
}

.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.student-actions {
  display: flex;
  padding: 0 16px 16px;
  gap: 8px;
  justify-content: flex-end;
}

.btn-action {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-action:active {
  transform: scale(0.95);
}

.btn-action.edit {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.btn-action.delete {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Offcanvas Styles */
.offcanvas-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
}

.offcanvas-back {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  margin-right: 12px;
}

.offcanvas-back:active {
  background: #f5f7fa;
}

.offcanvas-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.offcanvas-body {
  padding: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.form-control, .form-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus, .form-select:focus {
  outline: none;
  border-color: #0056c2;
  box-shadow: 0 0 0 3px rgba(0, 86, 194, 0.1);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #0056c2;
  color: white;
}

.btn-primary:active {
  background: #003a75;
}

.btn-secondary {
  background: #f5f7fa;
  color: #7f8c8d;
}

.btn-secondary:active {
  background: #e9ecef;
}

@media (max-width: 480px) {
  .csv-card {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .student-card-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  
  .student-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}


   .a4 {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  margin: auto;
  background: white;
  font-family: "Noto Serif Devanagari", serif;
  font-size: 14px;
  color: #000;
}

/* 🔴 Purple Heading (PDF jaisa) */
.text-purple {
  color: #d100d1; /* PDF purple */
}

/* 🔵 Photo Box (Blue) */
.photo-box {
  width: 110px;
  height: 135px;
  border: 2px solid #2b6cb0;
  background: #5b9bd5;
  color: #fff;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 🟣 Purple dotted lines */
.line {
  display: inline-block;
  border-bottom: 2px dotted #7a1fa2;
  width: 120px;
}

.long-line {
  display: inline-block;
  border-bottom: 2px dotted #7a1fa2;
  width: 100%;
}

/* spacing */
.form-line {
  margin-top: 6px;
}

/* ⭐ stars */
.star {
  color: red;
  font-size: 16px;
  margin: 0 6px;
}

/* 🟡 Yellow strip title */
.form-title {
  background: #ffe600;
  color: #d10000;
  font-weight: bold;
  padding: 3px 14px;
  border-radius: 2px;
}

/* 🟡 Office / Rules title */
.office-title,
.rules-title {
  background: #ffe600;
  color: #d10000;
  font-weight: bold;
  padding: 3px 14px;
  display: inline-block;
}


@media print {

  /* Hide app header & background */
  .app-header,
  .back-button,
  .header-action,
  .spinner-container {
    display: none !important;
  }

  /* Remove background */
  body,
  .app-container,
  .main-content {
    background: white !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Show only A4 pages */
  .admission-page {
    page-break-after: always;
  }

  /* Remove box shadows */
  * {
    box-shadow: none !important;
  }
}











</style>